import { PricePlanTypeEnum } from 'common/enums/PricePlanTypeEnum'
import { TaxBehaviorEnum } from 'common/enums/PricingEnum'
import { SubscriptionPlanIntervalEnum } from 'common/enums/SubscriptionPlanIntervalEnum'
import { CurrencyEnum } from 'common/types/CurrencyType'
import { ProductInterface } from 'common/types/entities/ProductInterface'
import { OneShotPlan, SubscriptionPlan } from 'common/types/OfferInterface'
import { createOfferPrice } from 'src/shared/entities/offer-price/create-offer-price'
import { CalculatePriceResponse } from 'src/shared/types/pricing-types'

const entity = createOfferPrice('storybook-root')

export const mockedOfferLineUiProps = {
  nameFontSize: entity.nameFontSize,
  mobileNameFontSize: entity.mobileNameFontSize,
  nameFontStyle: entity.nameFontStyle,
  mobileNameFontStyle: entity.mobileNameFontStyle,
  nameFontWeight: entity.nameFontWeight,
  mobileNameFontWeight: entity.mobileNameFontWeight,
  nameLineHeight: entity.nameLineHeight,
  mobileNameLineHeight: entity.mobileNameLineHeight,
  nameColor: entity.nameColor,
  mobileNameColor: entity.mobileNameColor,
  amountFontFamily: entity.amountFontFamily,
  mobileAmountFontFamily: entity.mobileAmountFontFamily,
  amountFontSize: entity.amountFontSize,
  mobileAmountFontSize: entity.mobileAmountFontSize,
  amountFontStyle: entity.amountFontStyle,
  mobileAmountFontStyle: entity.mobileAmountFontStyle,
  amountFontWeight: entity.amountFontWeight,
  mobileAmountFontWeight: entity.mobileAmountFontWeight,
  amountLineHeight: entity.amountLineHeight,
  mobileAmountLineHeight: entity.mobileAmountLineHeight,
  amountColor: entity.amountColor,
  mobileAmountColor: entity.mobileAmountColor,
  descriptionFontFamily: entity.descriptionFontFamily,
  mobileDescriptionFontFamily: entity.mobileDescriptionFontFamily,
  descriptionFontSize: entity.descriptionFontSize,
  mobileDescriptionFontSize: entity.mobileDescriptionFontSize,
  descriptionFontStyle: entity.descriptionFontStyle,
  mobileDescriptionFontStyle: entity.mobileDescriptionFontStyle,
  descriptionFontWeight: entity.descriptionFontWeight,
  mobileDescriptionFontWeight: entity.mobileDescriptionFontWeight,
  descriptionLineHeight: entity.descriptionLineHeight,
  mobileDescriptionLineHeight: entity.mobileDescriptionLineHeight,
  descriptionColor: entity.descriptionColor,
  mobileDescriptionColor: entity.mobileDescriptionColor,
}

export const mockedOfferPriceAttrId = entity.htmlAttrId

export const mockedOfferPriceCustomDescription = entity.customDescription

export const mockedMainProduct: ProductInterface = {
  id: 1,
  name: 'Sample product',
  tax: 0,
  sku: 'SKU-1',
  currency: CurrencyEnum.US_DOLLAR,
  price: 100,
  pricePlan: {
    id: 0,
    name: 'Default',
    currency: CurrencyEnum.US_DOLLAR,
    taxBehavior: TaxBehaviorEnum.Exclusive,
    type: PricePlanTypeEnum.OneShot,
    directChargeAmount: 100,
  },
  images: [],
  options: [],
  productVariants: [],
}

export const mockedBumpProduct: ProductInterface = {
  id: 2,
  name: 'Bump product',
  tax: 0,
  sku: 'SKU-2',
  currency: CurrencyEnum.US_DOLLAR,
  price: 30,
  pricePlan: {
    id: 0,
    name: 'Default',
    currency: CurrencyEnum.US_DOLLAR,
    taxBehavior: TaxBehaviorEnum.Exclusive,
    type: PricePlanTypeEnum.OneShot,
    directChargeAmount: 30,
  },
  images: [],
  options: [],
  productVariants: [],
}

export const mockedOneShotPlans: OneShotPlan[] = [
  {
    id: 1,
    name: 'One-off',
    currency: CurrencyEnum.US_DOLLAR,
    taxBehavior: TaxBehaviorEnum.Exclusive,
    type: PricePlanTypeEnum.OneShot,
    directChargeAmount: 100,
  },
]

export const mockedOneShotPlansPricing: CalculatePriceResponse[] = [
  {
    offerId: 1,
    pricePlan: 1,
    quantity: 1,
    originalAmount: 100,
    netAmount: 100,
    discountedNetAmount: 100,
    tax: { amount: 0, rate: 0 },
    grossAmount: 100,
    discount: { amount: 0, percent: 0 },
    shippingFee: { amount: 0, tax: { amount: 0, rate: 0 }, total: 0 },
    currencyCode: CurrencyEnum.US_DOLLAR,
    dueToday: 100,
    orderTotal: 100,
  },
]

export const mockedMainOfferPricingExclusiveTax: CalculatePriceResponse = {
  offerId: 1,
  pricePlan: 0,
  quantity: 1,
  originalAmount: 100,
  netAmount: 100,
  discountedNetAmount: 100,
  tax: { amount: 10, rate: 10 },
  grossAmount: 110,
  discount: { amount: 0, percent: 0 },
  shippingFee: { amount: 0, tax: { amount: 0, rate: 0 }, total: 0 },
  currencyCode: CurrencyEnum.US_DOLLAR,
  dueToday: 110,
  orderTotal: 110,
}

export const mockedBumpOfferPricing: CalculatePriceResponse = {
  offerId: 2,
  pricePlan: 0,
  quantity: 1,
  originalAmount: 30,
  netAmount: 30,
  discountedNetAmount: 30,
  tax: { amount: 0, rate: 0 },
  grossAmount: 30,
  discount: { amount: 0, percent: 0 },
  shippingFee: { amount: 0, tax: { amount: 0, rate: 0 }, total: 0 },
  currencyCode: CurrencyEnum.US_DOLLAR,
  dueToday: 30,
  orderTotal: 30,
}

export const mockedBumpOfferPricingExclusiveTax: CalculatePriceResponse = {
  offerId: 2,
  pricePlan: 0,
  quantity: 1,
  originalAmount: 30,
  netAmount: 30,
  discountedNetAmount: 30,
  tax: { amount: 3, rate: 10 },
  grossAmount: 33,
  discount: { amount: 0, percent: 0 },
  shippingFee: { amount: 0, tax: { amount: 0, rate: 0 }, total: 0 },
  currencyCode: CurrencyEnum.US_DOLLAR,
  dueToday: 33,
  orderTotal: 33,
}

export const mockedBumpPlan: OneShotPlan = {
  id: 2,
  name: 'Bump one-off',
  currency: CurrencyEnum.US_DOLLAR,
  taxBehavior: TaxBehaviorEnum.Exclusive,
  type: PricePlanTypeEnum.OneShot,
  directChargeAmount: 30,
}

export const mockedBumpPlanPricing: CalculatePriceResponse = {
  offerId: 2,
  pricePlan: 2,
  quantity: 1,
  originalAmount: 30,
  netAmount: 30,
  discountedNetAmount: 30,
  tax: { amount: 0, rate: 0 },
  grossAmount: 30,
  discount: { amount: 0, percent: 0 },
  shippingFee: { amount: 0, tax: { amount: 0, rate: 0 }, total: 0 },
  currencyCode: CurrencyEnum.US_DOLLAR,
  dueToday: 30,
  orderTotal: 30,
}

export const mockedSubscriptionPlan: SubscriptionPlan = {
  id: 3,
  name: 'Monthly subscription',
  currency: CurrencyEnum.US_DOLLAR,
  taxBehavior: TaxBehaviorEnum.Inclusive,
  type: PricePlanTypeEnum.Subscription,
  directChargeAmount: 0,
  isLimited: false,
  subscriptionPlan: {
    id: 1,
    amount: 100,
    trialPeriod: 0,
    trialInterval: SubscriptionPlanIntervalEnum.Month,
    interval: SubscriptionPlanIntervalEnum.Month,
    intervalCount: 1,
    limitOfPayments: null,
  },
}

export const mockedSubscriptionPlanPricing: CalculatePriceResponse = {
  offerId: 1,
  pricePlan: 3,
  quantity: 1,
  originalAmount: 100,
  netAmount: 90,
  discountedNetAmount: 90,
  tax: { amount: 10, rate: 10 },
  grossAmount: 100,
  discount: { amount: 0, percent: 0 },
  shippingFee: { amount: 0, tax: { amount: 0, rate: 0 }, total: 0 },
  currencyCode: CurrencyEnum.US_DOLLAR,
  dueToday: 100,
  orderTotal: 1200,
}

// Matches pricePlansStub plan IDs (1=limited_subscription 8€/mo, 2=one_shot 47.50€, 3=subscription 43.50€/mo)
export const mockedStubPlansPricing: CalculatePriceResponse[] = [
  {
    offerId: 0,
    pricePlan: 1,
    quantity: 1,
    originalAmount: 800,
    netAmount: 800,
    discountedNetAmount: 800,
    tax: { amount: 0, rate: 0 },
    grossAmount: 800,
    discount: { amount: 0, percent: 0 },
    shippingFee: { amount: 0, tax: { amount: 0, rate: 0 }, total: 0 },
    currencyCode: 'eur',
    dueToday: 0,
    orderTotal: 2400,
  },
  {
    offerId: 0,
    pricePlan: 2,
    quantity: 1,
    originalAmount: 4750,
    netAmount: 4750,
    discountedNetAmount: 4750,
    tax: { amount: 0, rate: 0 },
    grossAmount: 4750,
    discount: { amount: 0, percent: 0 },
    shippingFee: { amount: 0, tax: { amount: 0, rate: 0 }, total: 0 },
    currencyCode: 'eur',
    dueToday: 4750,
    orderTotal: 4750,
  },
  {
    offerId: 0,
    pricePlan: 3,
    quantity: 1,
    originalAmount: 4350,
    netAmount: 4350,
    discountedNetAmount: 4350,
    tax: { amount: 0, rate: 0 },
    grossAmount: 4350,
    discount: { amount: 0, percent: 0 },
    shippingFee: { amount: 0, tax: { amount: 0, rate: 0 }, total: 0 },
    currencyCode: 'eur',
    dueToday: 4350,
    orderTotal: 4350,
  },
]
